import { StockMovementType } from "../constants/stock-movement.constants";

/**
 * Mirrors backend `validateMovementRules` so the form fails fast with the same rules.
 */
export function validateMovementRules(
  movementType: StockMovementType,
  quantity: number,
  fromLocationId: number | null,
  toLocationId: number | null,
): void {
  const fromId = fromLocationId;
  const toId = toLocationId;

  switch (movementType) {
    case StockMovementType.PURCHASE:
      if (quantity <= 0) {
        throw new Error("PURCHASE quantity must be positive");
      }
      if (!toId) throw new Error("PURCHASE requires to location");
      if (fromId) throw new Error("PURCHASE must not set from location");
      break;
    case StockMovementType.ISSUE:
      if (quantity >= 0) {
        throw new Error("ISSUE quantity must be negative (stock out)");
      }
      if (!fromId) throw new Error("ISSUE requires from location");
      if (toId) throw new Error("ISSUE must not set to location");
      break;
    case StockMovementType.TRANSFER:
      if (!fromId || !toId) {
        throw new Error("TRANSFER requires from and to locations");
      }
      if (fromId === toId) {
        throw new Error("TRANSFER from and to locations must differ");
      }
      if (quantity <= 0) {
        throw new Error("TRANSFER quantity must be positive");
      }
      break;
    case StockMovementType.RETURN:
      if (quantity <= 0) {
        throw new Error("RETURN quantity must be positive");
      }
      if (!toId) throw new Error("RETURN requires to location");
      break;
    case StockMovementType.ADJUSTMENT: {
      const hasFrom = fromId != null;
      const hasTo = toId != null;
      if ((hasFrom && hasTo) || (!hasFrom && !hasTo)) {
        throw new Error(
          "ADJUSTMENT requires exactly one of from location or to location",
        );
      }
      break;
    }
    default:
      throw new Error("Unsupported movement type");
  }
}
